import { createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';
import * as API from '../api/index.js';
import { toggleModal } from '../reducers/generalReducer.js';
import { fetchTeamEvents } from './calendarThunks.js';
import { canCreateEventByDate } from './helper.js';

export const fetchWorkingDay = createAsyncThunk('workingDay/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const workingDay = await API.workingDay.getAll();
        return workingDay;
    } catch (err) {
        notification.error({
            message: 'Error when fetching work time',
            description: err.message,
        });
        return rejectWithValue(err.message);
    }
});

export const createWorkingDay = createAsyncThunk(
    'workingDay/create',
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDate(data.date);
            await canCreateEventByDate(data.insteadDate);
            await API.workingDay.create(data);
            await dispatch(fetchTeamEvents());
            dispatch(toggleModal({ modal: 'workingDay', isOpen: false }));
            notification.info({
                message: 'Success',
                description: 'Replacing working day was successfully',
            });
            return data;
        } catch (err) {
            notification.error({ message: 'ERROR', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);

export const updateWorkingDay = createAsyncThunk(
    'workingDay/update',
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            await canCreateEventByDate(data.date, id);
            await canCreateEventByDate(data.insteadDate, id);
            await API.workingDay.update(data, id);
            await dispatch(fetchTeamEvents());
            dispatch(toggleModal({ modal: 'workingDayEdit', isOpen: false }));
            dispatch(toggleModal({ modal: 'eventView', isOpen: false }));
            notification.info({
                message: 'Success',
                description: 'Replacing working day was updated',
            });
            return true;
        } catch (err) {
            notification.error({ message: 'ERROR', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);

export const deleteWorkingDay = createAsyncThunk('workingDay/delete', async ({ id }, { dispatch, rejectWithValue }) => {
    try {
        await API.workingDay.delete(id);
        await dispatch(fetchTeamEvents());
        dispatch(toggleModal({ modal: 'workingDayEdit', isOpen: false }));
        dispatch(toggleModal({ modal: 'eventView', isOpen: false }));
        notification.info({
            message: 'Success',
            description: 'Working day was deleted',
        });
        return true;
    } catch (err) {
        notification.error({ message: 'ERROR', description: err.message });
        return rejectWithValue(err.message);
    }
});

export const fetchWorkingDayStats = createAsyncThunk(
    'workingDay/stats',
    async ({ teamId, startDate, endDate }, { rejectWithValue }) => {
        try {
            const stats = await API.workingDay.getStats(teamId, startDate, endDate);
            return stats;
        } catch (err) {
            notification.error({ message: 'ERROR', description: err.message });
            return rejectWithValue(err.message);
        }
    },
);
